// Single source of truth for the standalone, Jira-style URLs each of these 5 entities is
// reachable at (apps/web/src/features/delivery/routes.tsx) — used by the Copy Link buttons now,
// and by whatever eventually generates notification actionUrls for these entity types later.

export function issueLink(projectId: string, issueKey: string): string {
  return `/delivery/projects/${projectId}/issues/${issueKey}`;
}

export function riskLink(projectId: string, riskKey: string): string {
  return `/delivery/projects/${projectId}/risks/${riskKey}`;
}

export function dependencyLink(projectId: string, dependencyKey: string): string {
  return `/delivery/projects/${projectId}/dependencies/${dependencyKey}`;
}

export function escalationLink(projectId: string, escalationKey: string): string {
  return `/delivery/projects/${projectId}/escalations/${escalationKey}`;
}

export function changeRequestLink(projectId: string, crNumber: string): string {
  return `/delivery/projects/${projectId}/change-requests/${crNumber}`;
}
